import React, { ComponentProps, useEffect } from 'react';
import { useRouting } from 'hooks/useRouting';
import { useCustomizeHeaderContext } from 'contexts/CustomizeHeaderContext';
import { PremiumCheck2 as PremiumCheck } from 'components/commons/premium-check/PremiumCheck';
import { TargetType, TargetTypes } from '../utils/type';
import { targetTypeToImg, targetTypes } from '../utils/targetInfo';
import { useBirthday } from '../utils/birthday';
import { useTargetSupportRouting } from '../hooks/useTargetSupportRouting';
import { TargetTypeCard } from '../components/features/create/TargetTypeCard';
import { NotFoundBirthday } from '../components/features/birthday/NotFoundBirthday';
import { TargetPremium } from '../components/features/TargetPremium';

const TargetTypeCards = ({
  className,
  targetTypes,
  onClickCard,
}: {
  targetTypes: TargetTypes[];
  onClickCard: (targetType: TargetType) => void;
  className?: string;
}): React.ReactElement => {
  const sortedTargetTypes = targetTypes
    .map(type => {
      const description = type.description;
      const roughTargetAmount = type.roughTargetAmount;
      const isRecommendMark = type.isRecommendMark ?? false;

      const subInformation: ComponentProps<
        typeof TargetTypeCard
      >['subInformation'] =
        description && roughTargetAmount
          ? type.accounts
            ? {
                tag: 'recommendsAndSubInformation',
                description,
                recommendAccounts: type.accounts,
                roughTargetAmount,
                isRecommendMark,
              }
            : {
                tag: 'subInformationOnly',
                description,
                roughTargetAmount,
              }
          : {
              tag: 'nothing',
            };
      return {
        subInformation,
        type,
      };
    })
    .sort((a, b) => {
      return a.type.sort - b.type.sort;
    });
  return (
    <>
      {sortedTargetTypes.length && (
        <div className={` ${className ?? ''}`}>
          <div className={`flex flex-col gap-4`}>
            {sortedTargetTypes.map(({ subInformation, type }, i) => {
              return (
                <TargetTypeCard
                  key={i}
                  {...{
                    imgPath: targetTypeToImg(type.targetType),
                    onClick: () => onClickCard(type.targetType),
                    subInformation,
                    title: type.title,
                    recommendAccounts: type.accounts,
                  }}
                />
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

const TargetSelect = (): React.ReactElement => {
  const { setWithBackIconWord } = useCustomizeHeaderContext();
  const { goTargetIndex } = useTargetSupportRouting();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(setWithBackIconWord, []);

  const { setBack } = useCustomizeHeaderContext();
  useEffect(() => {
    setBack({ backFunction: () => goTargetIndex() });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const routing = useRouting();
  const onClickCard = (targetType: TargetType) => {
    routing.replaceRouting({ path: `/target/create/${targetType}` }, true);
  };

  const { birthday } = useBirthday();

  if (birthday === null || birthday === undefined)
    return (
      <>
        <PremiumCheck content={<TargetPremium />}>
          <NotFoundBirthday />
        </PremiumCheck>
      </>
    );

  return (
    <PremiumCheck content={<TargetPremium />}>
      <div className={`p-4 `}>
        <div className={`font-bold text-base text-bluegray-700`}>
          目標の設定
        </div>
        <TargetTypeCards
          className={`mt-3.5`}
          targetTypes={targetTypes}
          onClickCard={onClickCard}
          key="おすすめ目標"
        />
      </div>
    </PremiumCheck>
  );
};

export default TargetSelect;
